import React, { useRef } from 'react'
import { useUpdateEffect } from 'react-use'
import produce from 'immer'
import { motion, AnimatePresence } from 'framer-motion'

import _ from 'lodash'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content } from '@/store/template/content'
import {
  undoHistoryAction,
  undoHistoryActionCount,
} from '@/store/builder/history'
import { isBuilder } from '@/store/builder/store'

import { FaAsterisk } from 'react-icons/fa'
import Classnames from 'classnames'

import ContentEditable from 'react-contenteditable'
import TextareaAutosize from 'react-textarea-autosize'

function MultiShortTextDisplay({ id, sectionData, index }) {
  const [getContent, setContent] = useRecoilState(content(id))
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getHistoryAction, setHistoryAction] = useRecoilState(undoHistoryAction)
  const [getHistoryActionCount, setHistoryActionCount] = useRecoilState(
    undoHistoryActionCount
  )

  const blockIndex = _.findIndex(getContent.blocks, { id: sectionData.id })

  const contentEditable = React.createRef()

  // undoSystem -- Content System
  useUpdateEffect(async () => {
    if (isBuilderApp) {
      if (!getHistoryAction) {
        setHistoryActionCount(getHistoryActionCount + 1)
      } else {
        setHistoryAction(false)
      }
    }
  }, [getContent])

  const answerTextChange = e => {
    const nextState = produce(getContent, draft => {
      draft.blocks[blockIndex].answer = e.target.value
    })
    setContent(nextState)
  }

  return (
    <div>
      <AnimatePresence>
        {getContent.blocks[blockIndex].answer && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.15 }}
            variants={{
              hidden: {
                opacity: 0,
                y: 5,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
              exit: {
                opacity: 0,
                y: -5,
              },
            }}
            className="mb-3 font-bold"
          >
            {sectionData.placeholder}
          </motion.div>
        )}
      </AnimatePresence>

      {/* <ContentEditable className={'shortTextAnswer outline-none'} html={getContent.blocks[blockIndex].answer} innerRef={contentEditable} onChange={answerTextChange} placeholder={sectionData.placeholder} /> */}
      <TextareaAutosize
        className={Classnames(
          'block resize-none w-full shortTextAnswer outline-none',
          {
            shortTextAnswerBlue: sectionData.color?.id == 'blue',
            shortTextAnswerGreen: sectionData.color?.id == 'green',
            shortTextAnswerRed: sectionData.color?.id == 'red',
            shortTextAnswerPurple: sectionData.color?.id == 'purple',
            shortTextAnswerYellow: sectionData.color?.id == 'yellow',
            shortTextAnswerGray: sectionData.color?.id == 'gray',
          }
        )}
        value={getContent.blocks[blockIndex].answer}
        placeholder={sectionData.placeholder}
        onChange={answerTextChange}
      />

      {sectionData.subtitle && (
        <div className="flex shortTextInputSubtitle mt-5 text-sm opacity-75">
          <div className="mr-2 mt-1 text-xs opacity-40 shortTextAnswerAster">
            <FaAsterisk />
          </div>
          <div className="font-medium">{sectionData.subtitle}</div>
        </div>
      )}
    </div>
  )
}

export default MultiShortTextDisplay
